import { BrowserWebcamStreamingConfig } from '../Interfaces/BrowserWebcamStreaming';
import { browserWebcamStreamingStore } from '../stores/browserWebcamStreaming';

export interface BrowserWebcamStreamingProps {
    browser_webcam_streaming_enabled?: boolean;
    browser_webcam_streaming_config?: BrowserWebcamStreamingConfig | null;
}

export async function ensureExamBrowserWebcamStarted(props: BrowserWebcamStreamingProps) {
    if (!props.browser_webcam_streaming_enabled) {
        return;
    }

    const store = browserWebcamStreamingStore();
    await store.ensureStarted(props.browser_webcam_streaming_config);
}
